import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => api.post("/auth/refresh").then(() => api.get("/auth/me")).then((r) => setUser(r.data)).catch(() => setUser(false)));
  }, []);

  const login = async (email, password) => setUser((await api.post("/auth/login", { email, password })).data);
  const register = async (name, email, password) => setUser((await api.post("/auth/register", { name, email, password })).data);
  const logout = async () => { await api.post("/auth/logout").catch(() => {}); setUser(false); };

  return <AuthContext.Provider value={{ user, login, register, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
